import React from 'react'
import { WizButton } from 'wiz-components';

const stateArr = ['待点评', '待反馈', '无需反馈', '已反馈']
export default (handleRow) => [

  {
    title: '月度',
    dataIndex: 'monthly',
    key: 'monthly',
    align: 'center',
    width: 100
  },
  {
    title: '总分',
    dataIndex: 'totalScore',
    key: 'totalScore',
    align: 'center',
    width: 100
  },
  {
    title: '大区排名',
    dataIndex: 'regionRanking',
    key: 'regionRanking',
    align: 'center',
    width: 100
  },
  {
    title: '全国平均分',
    dataIndex: 'nationalAvgScore',
    key: 'nationalAvgScore',
    align: 'center',
    width: 100
  },
  {
    title: '大区平均分',
    dataIndex: 'regionAvgScore',
    key: 'regionAvgScore',
    align: 'center',
    width: 100
  },
  {
    title: '全国排名',
    dataIndex: 'nationalRanking',
    key: 'nationalRanking',
    align: 'center',
    width: 100
  },
  // {
  //   title: '状态',
  //   dataIndex: 'state',
  //   key: 'state',
  //   align: 'center',
  //   width: '12.5%',
  //   render: (text, row, index) => (text ? stateArr[text - 1] : null)
  // },
  {
    title: '操作',
    align: 'center',
    width: 100,
    render: (text, row, index) => (
      <WizButton
      type='link'
      onClick={()=>handleRow(row)}
      >
        查看
      </WizButton>
    )
  }
];
